import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Ban, Home, Heart } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: '#0f0a1e', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div className="glass-card" data-testid="payment-cancel-card" style={{ maxWidth: 520, width: '100%', padding: 'clamp(32px, 6vw, 56px)', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
          <Ban size={64} color="#f59e0b" />
        </div>
        <h1 style={{ fontSize: 'clamp(24px, 4vw, 32px)', fontWeight: 700, color: '#ffffff', marginBottom: 14 }}>
          Donation Cancelled
        </h1>
        <p style={{ fontSize: 15, color: '#b0adc0', lineHeight: 1.8, marginBottom: 32 }}>
          No charge was made. Whenever you're ready, your support is always welcome — every contribution makes a difference.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            className="btn-primary-gradient"
            data-testid="payment-cancel-retry-btn"
            onClick={() => navigate('/#donate')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
          >
            <Heart size={18} /> Try Again
          </button>
          <button
            data-testid="payment-cancel-home-btn"
            onClick={() => navigate('/')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', fontSize: 15, fontWeight: 600, cursor: 'pointer', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(139,92,246,0.25)', borderRadius: 999, color: '#e0dff0', fontFamily: 'Inter, sans-serif' }}
          >
            <Home size={18} /> Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
